<div class="my-overlay" *ngIf="showOverlay">
  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
</div>
<div *ngIf="signupInformations">
  <app-modal>
    <div class="row pt-8px w-100">
      <div class="col-12 p-0">
        <button type="button" class="close pr-0" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="row center">
      <div class="col pl-40px pr-40px">
        <img alt="" src="../../../../../assets/img/logo_go_contratos.png">
        <div class="bottom-bordered"></div>
      </div>
    </div>
    <div class="row pt-24px">
      <div class="col">
        <div class="row center">
          <div class="col">
            <img class="h-40" src="../../../../../assets/icons/DESKTOP/Grupo 202.png" alt="">
          </div>
        </div>
        <div class="row center">
          <div class="col">
            <span class="f-20">
              {{i18n.SIGNATURE.ASSINAR_COMO}} {{signupInformations.signer.type}}
            </span>
          </div>
        </div>
        <div class="row center">
          <div class="col pl-40px pr-40px">
            <span class="f-16">
              {{signupInformations.signer.email}}
            </span>
            <div class="bottom-bordered"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-12px">
      <div class="col pl-40px pr-40px">
        <div class="row">
          <div class="col">
            <label for="signer-name" class="default-label">
              {{i18n.SIGNATURE.NOME_COMO_NO_CPF}}
            </label>
            <input id="signer-name" class="default-input" type="text" [(ngModel)]="signerData.name">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label for="signer-cpf" class="default-label">{{i18n.SIGNATURE.NUMERO_CPF}}</label>
            <input id="signer-cpf" mask="000.000.000-00" (input)="checkDocument()" class="default-input" type="text"
            [(ngModel)]="signerData.cpf">
            <br>
            <span class="f-red" *ngIf="validDocument === false">
              {{i18n.SIGNATURE.DOCUMENTO_INVALIDO}}
            </span>
          </div>
          <div class="col">
            <label for="signer-born" class="default-label">
              {{i18n.SIGNATURE.DATA_DE_NASCIMENTO}}
            </label>
            <input id="signer-born" mask="00/00/0000" [dropSpecialCharacters]="false" class="default-input" type="text" [(ngModel)]="signerData.born">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <app-signature-input [signatureName]="signerData.name" (signatureImg)="testeFunc($event)">
            </app-signature-input>
          </div>
        </div>
      </div>
    </div>

    <div class="row center justify-content-center pt-32px">
      <div class="col-7">
        <button [disabled]="
        validDocument === false ||
        signerData.name === '' ||
        signerData.signature === '' ||
        signerData.born === '' ||
        blockBtn
        " class="btn btn-blue" (click)="blockScreen();saveSignature();">
        {{i18n.SIGNATURE.ESTOU_DE_ACORDO}}
      </button>
    </div>
  </div>

  <div class="row pt-24px center pb-40px">
    <div class="col">
      <span class="f-opacited">
          {{i18n.SIGNATURE.PRE_TERMOS_DE_USO}}
          <br>
          <span class="f-blue" (click)="goToUseTerms()">
            {{i18n.SIGNATURE.TERMOS_DE_USO}}.
          </span>
        </span>
      </div>
    </div>
  </app-modal>
</div>
